// extracted by mini-css-extract-plugin
export default {"ariaSkipLinksContainer":"Ti-z"};